
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as edohSJSc9Acos6K2ukvq9YEda0hiUv1MbQSQNazgdYh0ocMeta } from "/var/www/2025-04-21_15_13/pages/edo.vue?macro=true";
import { default as helpZExiIomohd8IPcX4WoxfsAgEQjs3bqux5kiP_457qRDNMMeta } from "/var/www/2025-04-21_15_13/pages/help.vue?macro=true";
import { default as cargoiV6SjbqxgiOMbs4INmQqCvbeo_v_3NX_45P7yXEKhS5V0Meta } from "/var/www/2025-04-21_15_13/pages/cargo.vue?macro=true";
import { default as chinaM8svh6DcPIuBmHOzDiwr7dDNxOv42QJdZajJxJnorcsMeta } from "/var/www/2025-04-21_15_13/pages/china.vue?macro=true";
import { default as indexl7fvsd0kPt_rLrt51qbNlXgHF_aVbpS_45qifxK2tqjDwMeta } from "/var/www/2025-04-21_15_13/pages/index.vue?macro=true";
import { default as _91slug_93lq_45EZu1F_SeHl9j9GzEcdkz__45ClfLYpLznHLEBd5gREMeta } from "/var/www/2025-04-21_15_13/pages/[slug].vue?macro=true";
import { default as belarusaqmYpwa041yqRMNz6nngWZUqrqwIuujUFpCAJi4y2JQMeta } from "/var/www/2025-04-21_15_13/pages/belarus.vue?macro=true";
import { default as bonusesnE5gd7KLAOBHugjpry7okuqaN_45BzC33VrnE7ZEHkdrQMeta } from "/var/www/2025-04-21_15_13/pages/bonuses.vue?macro=true";
import { default as apiCkCH3bvNYyfHCKckQtuPXtWjBWj3XlFEmaIxCQ4tJWUMeta } from "/var/www/2025-04-21_15_13/pages/dev/api.vue?macro=true";
import { default as cms3TeSPZVakyAO8rJoshjbnJs2WOhW_45YTLhjMVaRzLweEMeta } from "/var/www/2025-04-21_15_13/pages/dev/cms.vue?macro=true";
import { default as konkurs_45Cq3m9_45hHZ_45BVAAPKG7b8fv1X9LTZX8HeEfI8JQ9y7QMeta } from "/var/www/2025-04-21_15_13/pages/konkurs.vue?macro=true";
import { default as successxU5bv1x4PG5CUuRGGG82HiAADo1bFAKFMM9asKUfaDYMeta } from "/var/www/2025-04-21_15_13/pages/success.vue?macro=true";
import { default as tariffsfS_NV1UheZsGEGukPiCqmVRoiCnkvd_45061KRTYF8Px4Meta } from "/var/www/2025-04-21_15_13/pages/tariffs.vue?macro=true";
import { default as vacancyhEfpUWz8Z9HCsAfAhg09X_6b_45U2GdB0bsEIkUQ0B2VAMeta } from "/var/www/2025-04-21_15_13/pages/vacancy.vue?macro=true";
import { default as contactsQDlVb1s3KEYqbXMwwfhjj5ZGU1go3tXIFIXtkyyNZXIMeta } from "/var/www/2025-04-21_15_13/pages/contacts.vue?macro=true";
import { default as giveawaypn0No_4519Z_45i4yw9PSqdmyx_45Lpq8URsfoCO4ToYTuB0QMeta } from "/var/www/2025-04-21_15_13/pages/giveaway.vue?macro=true";
import { default as guide_45lkfK_45qRt1LT0KrdHDgVy5JIPxjDsZiulyFtKRjZjxnswsMeta } from "/var/www/2025-04-21_15_13/pages/guide-lk.vue?macro=true";
import { default as servicesnj6wpSz1EcBpwxDoSKgapdzqv_7q1n2JLDQjRd6pkYcMeta } from "/var/www/2025-04-21_15_13/pages/services.vue?macro=true";
import { default as telegramieoK_454NDLhpS3TPuRoRtiVddqqhD9KBKlwy5RA0YUlEMeta } from "/var/www/2025-04-21_15_13/pages/telegram.vue?macro=true";
import { default as documentsrA9k_45pA64SCqDyGvAVXRfc3k0mZmwmB_FYs37TCKybgMeta } from "/var/www/2025-04-21_15_13/pages/documents.vue?macro=true";
import { default as franchisekky_pgqDqGl_45T7wEkEgxDze7N44VfJOI8eIb0JBdzYAMeta } from "/var/www/2025-04-21_15_13/pages/franchise.vue?macro=true";
import { default as insurance_45iYCYtWlJ9Lu7Zdm_M7SHQGPxroCoEdhzwCb3DKCxgcMeta } from "/var/www/2025-04-21_15_13/pages/insurance.vue?macro=true";
import { default as kirghiziaYozggD3v2ltUCw77_OV1dqeJAROvKVKOJT_45OWnRjNOYMeta } from "/var/www/2025-04-21_15_13/pages/kirghizia.vue?macro=true";
import { default as mapSchemeCuRiSMtnyHJxU_p8joWuMTuRAHuLkuYCYSLCaeYxBhMMeta } from "/var/www/2025-04-21_15_13/pages/mapScheme.vue?macro=true";
import { default as _91id_93OXskg3vLBO8VsCSvH9H6rQhxmw9QDyjGS_45psOp59wPEMeta } from "/var/www/2025-04-21_15_13/pages/news/[id].vue?macro=true";
import { default as return_45sdTlyoDkpb6yjJ170WFnjcMydwoj5jeiWoL8w1G58NE7gMeta } from "/var/www/2025-04-21_15_13/pages/return-sd.vue?macro=true";
import { default as smsClientN9fEbXCVGAzo3TlyzrHZ3Mw2ucxKm0h7QiU8iQmm_qsMeta } from "/var/www/2025-04-21_15_13/pages/smsClient.vue?macro=true";
import { default as terminalsncBOdpBA0ppzfQLA5JXbOa9sVprfAYH4TrIaSSmk_45IcMeta } from "/var/www/2025-04-21_15_13/pages/terminals.vue?macro=true";
import { default as iframeT1QN5QAvRdfPhaOIY9OMxgJwxy6mZAaVOCYYRea_YdYMeta } from "/var/www/2025-04-21_15_13/pages/dev/iframe.vue?macro=true";
import { default as directionszJeUwCL2OAKOF3DCjh2oXLkwxD16ZF3eKxcl64z5mQwMeta } from "/var/www/2025-04-21_15_13/pages/directions.vue?macro=true";
import { default as kazakhstanxkTGZXOJKpyC3CByDA1vOZ9Y_gBfR0SrmESmgrTFxIYMeta } from "/var/www/2025-04-21_15_13/pages/kazakhstan.vue?macro=true";
import { default as indexyXvk0cvYOjA66cDBlZrm8wuMsqzGXsQFl2td8XUgqjAMeta } from "/var/www/2025-04-21_15_13/pages/news/index.vue?macro=true";
import { default as svg6UojfOwoppryWk5e8ileHK1vSMk8mPyFI6S0sqovCnQMeta } from "/var/www/2025-04-21_15_13/pages/ui-kit/svg.vue?macro=true";
import { default as vzpay_45failApwd2Bt7Z0PTkqrtOYZi8BPtBIhNBapSytRjXIvR90EMeta } from "/var/www/2025-04-21_15_13/pages/vzpay-fail.vue?macro=true";
import { default as constructorxFSgMf8lZYt28YhnF45aadLLxO9EGNpLp7WyQvGs37kMeta } from "/var/www/2025-04-21_15_13/pages/constructor.vue?macro=true";
import { default as indexLEE508TnDoZrzjshKkEG5LI3MHxrTNAkRaGQuc2nki8Meta } from "/var/www/2025-04-21_15_13/pages/gifts/index.vue?macro=true";
import { default as information4RndQbgVrNWGuzt772894YXi3TtmjOkjrSsLRa8nIgwMeta } from "/var/www/2025-04-21_15_13/pages/information.vue?macro=true";
import { default as lightX3dpaR3TkuQ5jLFjMwSiQFIfSn6TKxZhZTVVB9HlvisMeta } from "/var/www/2025-04-21_15_13/pages/order/light.vue?macro=true";
import { default as claim_45filingX1__45yjC5TQIkFkLVtuHAkke9_45fE7z7Q5XYOjnLKdZgoMeta } from "/var/www/2025-04-21_15_13/pages/claim-filing.vue?macro=true";
import { default as _91type_93WUe1_ST49GaTUSq4RqmvFjp97TBNlYM3aWRJd_45oZft0Meta } from "/var/www/2025-04-21_15_13/pages/gifts/[type].vue?macro=true";
import { default as marketplacesgB6G7osAEkEzuR45_cFEKGjLNkktdnchRUWZsfrIMt4Meta } from "/var/www/2025-04-21_15_13/pages/marketplaces.vue?macro=true";
import { default as networkshopszW7KXcONP1lVLlCYoUWi_TLaUsTiOrWsvochRK30_wMMeta } from "/var/www/2025-04-21_15_13/pages/networkshops.vue?macro=true";
import { default as online_45storekk4jlf3vzXMX7ksl__45oCBHpOvsKwjaUf8010HkoIvkwMeta } from "/var/www/2025-04-21_15_13/pages/online-store.vue?macro=true";
import { default as managecUkqbjMVv0VeGJqkox0tRPbYJEcL3RBQg4WY6fRXAO4Meta } from "/var/www/2025-04-21_15_13/pages/order/manage.vue?macro=true";
import { default as registrationQf7C98ZHsdfllzEOuBT4jfMuW9AMDp6aixfYauCzo1sMeta } from "/var/www/2025-04-21_15_13/pages/registration.vue?macro=true";
import { default as run_45schedulehsSxfsHxARP5xlcBEjVJIX7MbxZB0Tfr9EKsB_45qhyY0Meta } from "/var/www/2025-04-21_15_13/pages/run-schedule.vue?macro=true";
import { default as safe_45custody1ComTAgXgqZHnNGvh1By7GeSHaMUw_7mlob7KZ8pvv0Meta } from "/var/www/2025-04-21_15_13/pages/safe-custody.vue?macro=true";
import { default as imagedrRP1q2dNq2K_k9a1v97CNoP0b8JoJs_45YBSiuD_45GHt8Meta } from "/var/www/2025-04-21_15_13/pages/ui-kit/image.vue?macro=true";
import { default as indexUd3rN3_w_VzTk3UnaUhgX1ipmo2gHxvLDOKbp6m_ymEMeta } from "/var/www/2025-04-21_15_13/pages/ui-kit/index.vue?macro=true";
import { default as bagjFdmbr3lwCzPfsj3BcppZ38aTxDBlnsytdpTa0wOaF8Meta } from "/var/www/2025-04-21_15_13/pages/wrapping/bag.vue?macro=true";
import { default as boxk2QBqS2HLpjkXSCOEQgHAvBszrvtzxsp_QPKRAPFvusMeta } from "/var/www/2025-04-21_15_13/pages/wrapping/box.vue?macro=true";
import { default as cargo_45loadingKaR8ZleLLRWxkfCn8wL1KVwyutj3WiAaevjb33TFeMoMeta } from "/var/www/2025-04-21_15_13/pages/cargo-loading.vue?macro=true";
import { default as happybirthday_45mjrOzhmWppU3T0I58vsqNMT02FW2zJNNiwTRnNpF_QMeta } from "/var/www/2025-04-21_15_13/pages/happybirthday.vue?macro=true";
import { default as manage__45ls8EI2X_MN4LHUZgVLYT_Bw3Um1sjKSIW1wfyaRbgMeta } from "/var/www/2025-04-21_15_13/pages/iframe/manage.vue?macro=true";
import { default as authizJRcj8MscjBN3ZlgzkHm7eJkZv5Rq_48M5Y8h8fvW0Meta } from "/var/www/2025-04-21_15_13/pages/personal/auth.vue?macro=true";
import { default as publicFRVjJgrVDhEwbcQhPt7xVtRmF6mDWf4ErPLai8mumiUMeta } from "/var/www/2025-04-21_15_13/pages/ui-kit/public.vue?macro=true";
import { default as already_45answer6yykvnFMUbhUP9yH05ReWLxYHEnNkh4VzjH5lVYrw8UMeta } from "/var/www/2025-04-21_15_13/pages/already-answer.vue?macro=true";
import { default as tariffsHrw9pOemktDHjK0YG4f9BnBv9rTA52WZPxnU2BrIhOYMeta } from "/var/www/2025-04-21_15_13/pages/iframe/tariffs.vue?macro=true";
import { default as _91id_935myDq_45BjIL0t_41dM9TST6fl1pxZ_45FSdTkWmAKztyooMeta } from "/var/www/2025-04-21_15_13/pages/order/pay/[id].vue?macro=true";
import { default as indexbrR6k7lHMwYBuLIU10hOTWodZJUDkx2mndI9TQwYoRMMeta } from "/var/www/2025-04-21_15_13/pages/personal/index.vue?macro=true";
import { default as privacy_45policy_459Gfnn3jeYUCME8msVPE_gx01FgefMFYQRR6YgVSdZgMeta } from "/var/www/2025-04-21_15_13/pages/privacy-policy.vue?macro=true";
import { default as _91hash_930J61vggBsMqgbSy2hTg2aE8Z8Uw9cz8pQcDF6upPVfkMeta } from "/var/www/2025-04-21_15_13/pages/welcome/[hash].vue?macro=true";
import { default as indexebDxVJ1XeX7X5G31XtI7W_HVgV2oO_45X34yTj2EAGIfUMeta } from "/var/www/2025-04-21_15_13/pages/wrapping/index.vue?macro=true";
import { default as delivery_45russia3ac0x6lR2BIN_45qDrMUmdZcT2wNGi8dgAScyqb9XiAmsMeta } from "/var/www/2025-04-21_15_13/pages/delivery-russia.vue?macro=true";
import { default as payment_45methodssZna5KFRZ_457G6ygL0P7_1pe2kU8HzM22A_QnXNGUueQMeta } from "/var/www/2025-04-21_15_13/pages/payment-methods.vue?macro=true";
import { default as qr_45infomzphdPzYtixtaLc7VzzOKRl5RUsfhCRnCig1nZsIPHUMeta } from "/var/www/2025-04-21_15_13/pages/payment/qr-info.vue?macro=true";
import { default as successNm5OqhnWBvj_z5kGYMGuffHc6dVjAHyckwfa7tKyncsMeta } from "/var/www/2025-04-21_15_13/pages/payment/success.vue?macro=true";
import { default as importy9N3qLMaQGeJZCYMZth9Nb8dxqnkadbKQLxGRkxlcR4Meta } from "/var/www/2025-04-21_15_13/pages/personal/import.vue?macro=true";
import { default as logoutXeyhjMQ2g5ZRy01exVISn6Bf21dx_9YBsB4aAZdsczAMeta } from "/var/www/2025-04-21_15_13/pages/personal/logout.vue?macro=true";
import { default as address_45deliveryS6Hl6f1vdnQgXcnQbOzx_e9kgQV6oKpJK4U9_cZyZpcMeta } from "/var/www/2025-04-21_15_13/pages/address-delivery.vue?macro=true";
import { default as cash_45on_45deliveryogXDddw7cRe6V1ltlGo2n5kIfHB2kXiMoaF53NOZ6u4Meta } from "/var/www/2025-04-21_15_13/pages/cash-on-delivery.vue?macro=true";
import { default as happynewyear2024hUx1uV_OqZE80vy05NCEb0M4KBMMXB8MBVo7Qmy3XDAMeta } from "/var/www/2025-04-21_15_13/pages/happynewyear2024.vue?macro=true";
import { default as ozonZNlZOabiowwra1CD0lDVZIaKFEVJQKB2NZPmSCzyNnEMeta } from "/var/www/2025-04-21_15_13/pages/marketplace/ozon.vue?macro=true";
import { default as pay_45fail_b9go4dRmYBWOz2fuev4jkncQAHDW9ksxuPxDWPFQpMMeta } from "/var/www/2025-04-21_15_13/pages/payment/pay-fail.vue?macro=true";
import { default as accountlUuAyjKdWh2RSCdDS90rvojN6HaCVYQf9UsAIBrk95gMeta } from "/var/www/2025-04-21_15_13/pages/personal/account.vue?macro=true";
import { default as prohibited_45goodsphr1sCfnJWeBL3UjxMC04a3LOKKGRM45Rk_O8_456sitEMeta } from "/var/www/2025-04-21_15_13/pages/prohibited-goods.vue?macro=true";
import { default as directionhvFFSyKrdPP_45H3z_EYLeKAhr4dTyP_454CdlIaEVMfHscMeta } from "/var/www/2025-04-21_15_13/pages/ui-kit/direction.vue?macro=true";
import { default as free_45group_45pickupGq6soE2R1GHo8kXF4lrvMaTEZSP5Fa1YWvRYSyFSDgkMeta } from "/var/www/2025-04-21_15_13/pages/free-group-pickup.vue?macro=true";
import { default as free_45pickup_45cargoEIXcNfqjr71oOJ1kvNytfya7dHopdjoTgFeymMRQKcoMeta } from "/var/www/2025-04-21_15_13/pages/free-pickup-cargo.vue?macro=true";
import { default as calculatori3Hta6d4qBipG2OXdigCnBopQyqKLXV6Zy4kWCj1e5UMeta } from "/var/www/2025-04-21_15_13/pages/iframe/calculator.vue?macro=true";
import { default as merch_45for_45bonusestYRphDhkeZHHdILX5VWggpoFkpsx9Pm1MG_2oJzR0z0Meta } from "/var/www/2025-04-21_15_13/pages/merch-for-bonuses.vue?macro=true";
import { default as _91id_93z1DwK3HX61vy1TAKJZz4sBUZsnTq_Hbl_45CMIphEiopAMeta } from "/var/www/2025-04-21_15_13/pages/order/pay/qr/[id].vue?macro=true";
import { default as card_45info9YuZeWiCHPHVWZdgwkQB2k6FgGalm66gc7BbROv9q_45cMeta } from "/var/www/2025-04-21_15_13/pages/payment/card-info.vue?macro=true";
import { default as discountjcespzT3nbE4OmHgIdqw2TFp8CbRjL9G0xIWnMMTJtMMeta } from "/var/www/2025-04-21_15_13/pages/personal/discount.vue?macro=true";
import { default as hard_45boxIuHoATiMDAnUKkBf12hnwIPz36wyXeoIfTXKLFWpuWAMeta } from "/var/www/2025-04-21_15_13/pages/wrapping/hard-box.vue?macro=true";
import { default as forwarding_45receiptI_tOb1Q_sFNm7A1tVCiBrZZZ_45iRR8QWdDrRIx6SA8OAMeta } from "/var/www/2025-04-21_15_13/pages/forwarding-receipt.vue?macro=true";
import { default as mailClient10201917N8A5Tyk4UqZR7kV9qmeGnMEhlwCyOq1J4g2T6zerxNYMeta } from "/var/www/2025-04-21_15_13/pages/mailClient10201917.vue?macro=true";
import { default as mobile_45applicationgEoCAmM_coD3tKxa2P74_45RlgCgw_457veXkkyAonAMrp0Meta } from "/var/www/2025-04-21_15_13/pages/mobile-application.vue?macro=true";
import { default as indexRniHaUCMLUyZTYaMXyqTZ0mg7Zbu_45AZPobYWLhT33gUMeta } from "/var/www/2025-04-21_15_13/pages/order/create/index.vue?macro=true";
import { default as boatLw3w6LBi_8R_Cy5_456LC_456rvz7_bz5cgM0cPZl1CClMIMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/boat.vue?macro=true";
import { default as sofaXfP7bt3i3WDrY6_453LTTz7gjHuv8dnh_45w5MxH6oVNaRgMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/sofa.vue?macro=true";
import { default as cardboardjsE6keDonoqvTZ9jwRzi2u0HjMSALTTOMWLLQ91U_RsMeta } from "/var/www/2025-04-21_15_13/pages/wrapping/cardboard.vue?macro=true";
import { default as promocodesh8Us6sol_IFoR169lE8P9awC3eWSaYSADfsqxH8HUC0Meta } from "/var/www/2025-04-21_15_13/pages/personal/promocodes.vue?macro=true";
import { default as benchOMODtQfHfH6Wkc2P5Blv1hZp5nPnLBqSvM7YTtsJ8lcMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/bench.vue?macro=true";
import { default as booksJFluczgXgmd_45xrolkyivGTpuycNoAd2gQqAWJImVrPQMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/books.vue?macro=true";
import { default as cablepTzcdN7bMUXR9bvn7cOMBA4_vm3Y4UQs9_45apWR4V1zAMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/cable.vue?macro=true";
import { default as chairH0dZnOx3wDrUuIM4v4lRY49W7vtC_45kB4UMfIt8xr_45iAMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/chair.vue?macro=true";
import { default as goodszYHuSILz0BjSZ2WhWn7DaGWYQ7JJePV2Q6jyYJ5cAosMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/goods.vue?macro=true";
import { default as indexJ2TFMUopAQyOwrTwuPl89B5DIZXEez7PqDTea3QGdocMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/index.vue?macro=true";
import { default as metalZE_uZuy59l3_45PtYzKrYMkXfx0YNYFC1y_45QC_45AyrNIdIMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/metal.vue?macro=true";
import { default as pianoYExu6ZCxXpqHLAtSWRUOiusfRa0DB4pdu4eBjI0tI3oMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/piano.vue?macro=true";
import { default as pipesdaQA6xPpdWVk2UwXsyQWOU1hQvVY6RXiLQiuNiwgtxIMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/pipes.vue?macro=true";
import { default as toolsK4XU6XX92atNpjadR0PnLXrJ8jsbnKwlAFUpuC6S6dEMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/tools.vue?macro=true";
import { default as pallet_45boxRhaCOypV41FJP8K_45j530gI_45SVwhZdwJufdumeltAMgMMeta } from "/var/www/2025-04-21_15_13/pages/wrapping/pallet-box.vue?macro=true";
import { default as _91tab_93SXfoB8sLZqYvI0VUYBGKqJm9FsiPzkPoK0Vo_LXG7bsMeta } from "/var/www/2025-04-21_15_13/pages/personal/bonus/[tab].vue?macro=true";
import { default as printjgs0BXLvHX9wREGViBMZo_45OFPU_45IshH78w70seGOxMgMeta } from "/var/www/2025-04-21_15_13/pages/personal/order/print.vue?macro=true";
import { default as dishes_455spiveP16tl_UMShIWcSJJqtK8AIZh_45O0kuX9mpTvcMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/dishes.vue?macro=true";
import { default as enginePP9_FTRNhVT4ETH97m_45AUQoR6VQ6XQ_F2elOWkz1QuUMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/engine.vue?macro=true";
import { default as lumber4iyVHTEm8v4Bq6jIso_450RmA4VlCCNLrqddYlw0RSaCAMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/lumber.vue?macro=true";
import { default as wheelsFFpppzxiynlSYBSXcMtIhbjR9fYsVBhWuUG8Zqw0ohoMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/wheels.vue?macro=true";
import { default as bubble_45filmHAn9k_45C75Z7ToP7ld2upJE8DCUZmR0YBqKba0kJyqdEMeta } from "/var/www/2025-04-21_15_13/pages/wrapping/bubble-film.vue?macro=true";
import { default as palletising1rG7ZhdJWUH_45b4lxziC9Whh7IBiqxMKiHn9C8cXThBwMeta } from "/var/www/2025-04-21_15_13/pages/wrapping/palletising.vue?macro=true";
import { default as fast_45delivery_45capitaljkAvbLf1y6Sp6J2ag_45b0iXnOyafCMFTsntTakmrlnnsMeta } from "/var/www/2025-04-21_15_13/pages/fast-delivery-capital.vue?macro=true";
import { default as _91guid_93wKwqZzWqHPw7R7CmfitAw_45BnILI6gPRo8chVWOYPmDQMeta } from "/var/www/2025-04-21_15_13/pages/personal/order/[guid].vue?macro=true";
import { default as createTXKPDArZ4SFyEUb4GbgcSJ6ymrXc_45taZPxk_45sHIEV3QMeta } from "/var/www/2025-04-21_15_13/pages/personal/order/create.vue?macro=true";
import { default as barrelsGTYpBj6fRbU64txHmlRcsQTt01U_4558NbPxzPbJzWfe8Meta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/barrels.vue?macro=true";
import { default as clothesFO5u3qXLNfm_10WcdQX65IEB7dl64WmQeDaVx_AN_45b8Meta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/clothes.vue?macro=true";
import { default as fragilejIuJ7eeYDj_c46JJRRtlSWvHxUAkFkR64Mwwh6uLGwEMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/fragile.vue?macro=true";
import { default as trailerBnl74OAVRq9_Is6j7Eou7OHatMOUU1y2752O3EEO25AMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/trailer.vue?macro=true";
import { default as safe_45packageUN9NPx_45r25CtocGWnXdpejOpsBeK1aEDhfNFOy72BEsMeta } from "/var/www/2025-04-21_15_13/pages/wrapping/safe-package.vue?macro=true";
import { default as bepaid_45successRAg2K6JuFYed_45ZyLNfXwf61aAvqLpeQnUKp_BToZ_45WIMeta } from "/var/www/2025-04-21_15_13/pages/payment/bepaid-success.vue?macro=true";
import { default as extra_45package2Uf3WoYQnW8f6Z2sff0Htk5vQfMJllarp83xGKSW0cMMeta } from "/var/www/2025-04-21_15_13/pages/wrapping/extra-package.vue?macro=true";
import { default as wildberriesJc6fQnmNbng3WZV7evgM_45aKwlzj8q3k90ZOvbJuNCqAMeta } from "/var/www/2025-04-21_15_13/pages/marketplace/wildberries.vue?macro=true";
import { default as _91guid_93BxlRxGGf_454DGqXPU_45HKcYz7aTwHOER3vn8FjnXv0jNwMeta } from "/var/www/2025-04-21_15_13/pages/order/administer/[guid].vue?macro=true";
import { default as furniturepBaQR8olL8Y6bl_eaKy474y7phCo5mYGx7_45PTe6FWyQMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/furniture.vue?macro=true";
import { default as oversizedUB4iFX728SKpGVXm56r5Fq7IKn6l974Lz8DFcbzZ88EMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/oversized.vue?macro=true";
import { default as quad_45bikeJPUYdanuTOV8hdA_QGK6MH5EcP99752LxdXIU_45axv2cMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/quad-bike.vue?macro=true";
import { default as _91locations_93e0TQCQQP0Zzbboyof_45OvylChDCAgvcvPDpApQhoBOhgMeta } from "/var/www/2025-04-21_15_13/pages/order/create/[locations].vue?macro=true";
import { default as _91_46_46_46tab_93zIAK0qUWGkilHeJnGrhFOZCtgdHXgFd0js6qg6IqCgMMeta } from "/var/www/2025-04-21_15_13/pages/personal/orders/[...tab].vue?macro=true";
import { default as auto_45partszn4gG9cZth_8tIY_wZEeHl_45mWtdpLwDGd98GejLfKf0Meta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/auto-parts.vue?macro=true";
import { default as newspapersbYn9AI0CvAHjZmhlgQWRpaqgF30jmSd0fzcrABCf8UQMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/newspapers.vue?macro=true";
import { default as smallcargofN7BshGyMZ_45iFHvQLz6tRSWYpix8hVgjkABiiZz2hMEMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/smallcargo.vue?macro=true";
import { default as snowmobile50EgwAuao_45X8jaTa70ah6Pp5p5JPI63Vb266MTYtvOYMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/snowmobile.vue?macro=true";
import { default as index_JymTZA639nG_451OnqQyBaUOcZXc_bEfecExB__yEAfEMeta } from "/var/www/2025-04-21_15_13/pages/iframe/order/create/index.vue?macro=true";
import { default as yandex_45marketOQJgxP4o14w97HMQVqdJuvpMHPDdqfZG_45UpX6LhWtg8Meta } from "/var/www/2025-04-21_15_13/pages/marketplace/yandex-market.vue?macro=true";
import { default as templatesg_45j8sct_45kXjy7qf8bd9dgp3Ha6aOk5Pg8BHNOvSkNR4Meta } from "/var/www/2025-04-21_15_13/pages/personal/orders/templates.vue?macro=true";
import { default as indexPC_8ONyzYoLzLrjZ5PQFgKLihGjY003gNi_45A1WqF42IMeta } from "/var/www/2025-04-21_15_13/pages/personal/contractors/index.vue?macro=true";
import { default as refrigerator86iALEsQXgthdA0WK9V42Thbul8NlrGwe5VoaZMwr54Meta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/refrigerator.vue?macro=true";
import { default as _91guid_93_j9W_45E_DNlgXkHFuKOb_45oZZi5xKWjNL1kpR_qifSRaEMeta } from "/var/www/2025-04-21_15_13/pages/personal/contractors/[guid].vue?macro=true";
import { default as indexXJ7xU4G3qbB5xQ_45EpJ76LqBNOGfh2TTAj2RpZkllzhgMeta } from "/var/www/2025-04-21_15_13/pages/personal/multi-pickup/index.vue?macro=true";
import { default as _91guid_93nop5lB0gwq2UGpsQScqlUDB6_45qks3wzG27_45dVqZ2f34Meta } from "/var/www/2025-04-21_15_13/pages/personal/multi-pickup/[guid].vue?macro=true";
import { default as consumer_45goodsJIFB7LUIdJdiHPfKU1bMf8JHDSgrtmXk4vlzNJ5X4AYMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/consumer-goods.vue?macro=true";
import { default as indexubXP3AwqrlSxS75cWG6V0KcWCAv4tENs9CCwX2tqCgkMeta } from "/var/www/2025-04-21_15_13/pages/personal/group-printing/index.vue?macro=true";
import { default as indexqnqP7IsKIIXSuNYeZLZyMzwW9YE23Ckrp4DHtYCydoAMeta } from "/var/www/2025-04-21_15_13/pages/personal/multi-delivery/index.vue?macro=true";
import { default as medical_45devicesNyPFh0LboK0lGp1o_FmG2cOCH5OSp13lXeXi3LOGuhcMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/medical-devices.vue?macro=true";
import { default as _91guid_93B142TTO2LCoLcqe4Qyxu0DyYKB4KY5lPAosooy9b0HMMeta } from "/var/www/2025-04-21_15_13/pages/iframe/order/administer/[guid].vue?macro=true";
import { default as _91guid_93T_edXAxDoyja6VKfCH1Z0UORs4aCqp0oDM7klIQI6YsMeta } from "/var/www/2025-04-21_15_13/pages/personal/multi-delivery/[guid].vue?macro=true";
import { default as _91_46_46_46id_93eMxPJRxlUx7eKtLracMY6maRczv8_IxiFIpIBJ7R0b0Meta } from "/var/www/2025-04-21_15_13/pages/personal/order/template/[...id].vue?macro=true";
import { default as special_45equipmentW_453RdW4H_m28_EfQqzaCraeHPjS5uaIwxh_45fKECfWagMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/special-equipment.vue?macro=true";
import { default as building_45materialsUGJYk5K6_45poVIxf0uNTSB39khcbVoTwh3Vgpl0rG_HEMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/building-materials.vue?macro=true";
import { default as musical_45instrumentsiGpttfsy5SKyU1RU0NX3VL01_iXs2aCvFXxQ7_45rJWs8Meta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/musical-instruments.vue?macro=true";
import { default as industrial_45equipmentPUozjIjhYMRIyVYBFVoDsD6UOSL45BVNPM3kBsW4SuwMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/industrial-equipment.vue?macro=true";
import { default as motorcycletransportationrpGF2K10pvdPQFtFv1LaGHPQGXIq1NLejX6H8xsmnYoMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/motorcycletransportation.vue?macro=true";
import { default as _91locationFrom_93__91locationTo_93UmN_m_45Jewg_SehoPnQ42bSAgUDSGd5NAToheYj0FyqkMeta } from "/var/www/2025-04-21_15_13/pages/order/create/[locationFrom]_[locationTo].vue?macro=true";
import { default as personalitemstransportationxXWilxT5tF3kOqN_0V6MtM9jXj6tll4_qgQ5TptL_pIMeta } from "/var/www/2025-04-21_15_13/pages/shippingtypes/personalitemstransportation.vue?macro=true";
export default [
  {
    name: "edo",
    path: "/edo",
    component: () => import("/var/www/2025-04-21_15_13/pages/edo.vue")
  },
  {
    name: "help",
    path: "/help",
    component: () => import("/var/www/2025-04-21_15_13/pages/help.vue")
  },
  {
    name: "cargo",
    path: "/cargo",
    component: () => import("/var/www/2025-04-21_15_13/pages/cargo.vue")
  },
  {
    name: "china",
    path: "/china",
    component: () => import("/var/www/2025-04-21_15_13/pages/china.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/var/www/2025-04-21_15_13/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug()",
    meta: _91slug_93lq_45EZu1F_SeHl9j9GzEcdkz__45ClfLYpLznHLEBd5gREMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/[slug].vue")
  },
  {
    name: "belarus",
    path: "/belarus",
    component: () => import("/var/www/2025-04-21_15_13/pages/belarus.vue")
  },
  {
    name: "bonuses",
    path: "/bonuses",
    component: () => import("/var/www/2025-04-21_15_13/pages/bonuses.vue")
  },
  {
    name: "dev-api",
    path: "/dev/api",
    component: () => import("/var/www/2025-04-21_15_13/pages/dev/api.vue")
  },
  {
    name: "dev-cms",
    path: "/dev/cms",
    component: () => import("/var/www/2025-04-21_15_13/pages/dev/cms.vue")
  },
  {
    name: "konkurs",
    path: "/konkurs",
    meta: konkurs_45Cq3m9_45hHZ_45BVAAPKG7b8fv1X9LTZX8HeEfI8JQ9y7QMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/konkurs.vue")
  },
  {
    name: "success",
    path: "/success",
    component: () => import("/var/www/2025-04-21_15_13/pages/success.vue")
  },
  {
    name: "tariffs",
    path: "/tariffs",
    component: () => import("/var/www/2025-04-21_15_13/pages/tariffs.vue")
  },
  {
    name: "vacancy",
    path: "/vacancy",
    component: () => import("/var/www/2025-04-21_15_13/pages/vacancy.vue")
  },
  {
    name: "contacts",
    path: "/:tag(address|contacts)/:location?",
    meta: contactsQDlVb1s3KEYqbXMwwfhjj5ZGU1go3tXIFIXtkyyNZXIMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/contacts.vue")
  },
  {
    name: "giveaway",
    path: "/giveaway",
    component: () => import("/var/www/2025-04-21_15_13/pages/giveaway.vue")
  },
  {
    name: "guide-lk",
    path: "/guide-lk",
    component: () => import("/var/www/2025-04-21_15_13/pages/guide-lk.vue")
  },
  {
    name: "services",
    path: "/services",
    component: () => import("/var/www/2025-04-21_15_13/pages/services.vue")
  },
  {
    name: "telegram",
    path: "/telegram",
    component: () => import("/var/www/2025-04-21_15_13/pages/telegram.vue")
  },
  {
    name: "documents",
    path: "/documents",
    component: () => import("/var/www/2025-04-21_15_13/pages/documents.vue")
  },
  {
    name: "franchise",
    path: "/franchise",
    component: () => import("/var/www/2025-04-21_15_13/pages/franchise.vue")
  },
  {
    name: "insurance",
    path: "/insurance",
    component: () => import("/var/www/2025-04-21_15_13/pages/insurance.vue")
  },
  {
    name: "kirghizia",
    path: "/kirghizia",
    component: () => import("/var/www/2025-04-21_15_13/pages/kirghizia.vue")
  },
  {
    name: "mapScheme",
    path: "/mapScheme",
    meta: mapSchemeCuRiSMtnyHJxU_p8joWuMTuRAHuLkuYCYSLCaeYxBhMMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/mapScheme.vue")
  },
  {
    name: "news-id",
    path: "/:tag(news|actions)/:id",
    meta: _91id_93OXskg3vLBO8VsCSvH9H6rQhxmw9QDyjGS_45psOp59wPEMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/news/[id].vue")
  },
  {
    name: "return-sd",
    path: "/return-sd",
    component: () => import("/var/www/2025-04-21_15_13/pages/return-sd.vue")
  },
  {
    name: "smsClient",
    path: "/smsClient",
    component: () => import("/var/www/2025-04-21_15_13/pages/smsClient.vue")
  },
  {
    name: "terminals",
    path: "/terminals",
    component: () => import("/var/www/2025-04-21_15_13/pages/terminals.vue")
  },
  {
    name: "dev-iframe",
    path: "/dev/iframe",
    component: () => import("/var/www/2025-04-21_15_13/pages/dev/iframe.vue")
  },
  {
    name: "directions",
    path: "/directions",
    component: () => import("/var/www/2025-04-21_15_13/pages/directions.vue")
  },
  {
    name: "kazakhstan",
    path: "/kazakhstan",
    component: () => import("/var/www/2025-04-21_15_13/pages/kazakhstan.vue")
  },
  {
    name: "news",
    path: "/:tag(news|actions)",
    meta: indexyXvk0cvYOjA66cDBlZrm8wuMsqzGXsQFl2td8XUgqjAMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/news/index.vue")
  },
  {
    name: "ui-kit-svg",
    path: "/ui-kit/svg",
    component: () => import("/var/www/2025-04-21_15_13/pages/ui-kit/svg.vue")
  },
  {
    name: "vzpay-fail",
    path: "/vzpay-fail",
    component: () => import("/var/www/2025-04-21_15_13/pages/vzpay-fail.vue")
  },
  {
    name: "constructor",
    path: "/constructor",
    meta: constructorxFSgMf8lZYt28YhnF45aadLLxO9EGNpLp7WyQvGs37kMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/constructor.vue")
  },
  {
    name: "gifts",
    path: "/gifts",
    meta: indexLEE508TnDoZrzjshKkEG5LI3MHxrTNAkRaGQuc2nki8Meta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/gifts/index.vue")
  },
  {
    name: "information",
    path: "/information",
    component: () => import("/var/www/2025-04-21_15_13/pages/information.vue")
  },
  {
    name: "order-light",
    path: "/order/light",
    component: () => import("/var/www/2025-04-21_15_13/pages/order/light.vue")
  },
  {
    name: "claim-filing",
    path: "/claim-filing",
    component: () => import("/var/www/2025-04-21_15_13/pages/claim-filing.vue")
  },
  {
    name: "gifts-type",
    path: "/gift/:type(m|o)",
    meta: _91type_93WUe1_ST49GaTUSq4RqmvFjp97TBNlYM3aWRJd_45oZft0Meta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/gifts/[type].vue")
  },
  {
    name: "marketplaces",
    path: "/marketplaces",
    component: () => import("/var/www/2025-04-21_15_13/pages/marketplaces.vue")
  },
  {
    name: "networkshops",
    path: "/networkshops",
    component: () => import("/var/www/2025-04-21_15_13/pages/networkshops.vue")
  },
  {
    name: "online-store",
    path: "/online-store",
    component: () => import("/var/www/2025-04-21_15_13/pages/online-store.vue")
  },
  {
    name: "order-manage",
    path: "/order/manage",
    component: () => import("/var/www/2025-04-21_15_13/pages/order/manage.vue")
  },
  {
    name: "registration",
    path: "/registration",
    component: () => import("/var/www/2025-04-21_15_13/pages/registration.vue")
  },
  {
    name: "run-schedule",
    path: "/run-schedule",
    component: () => import("/var/www/2025-04-21_15_13/pages/run-schedule.vue")
  },
  {
    name: "safe-custody",
    path: "/safe-custody",
    component: () => import("/var/www/2025-04-21_15_13/pages/safe-custody.vue")
  },
  {
    name: "ui-kit-image",
    path: "/ui-kit/image",
    component: () => import("/var/www/2025-04-21_15_13/pages/ui-kit/image.vue")
  },
  {
    name: "ui-kit",
    path: "/ui-kit",
    component: () => import("/var/www/2025-04-21_15_13/pages/ui-kit/index.vue")
  },
  {
    name: "wrapping-bag",
    path: "/wrapping/bag",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/bag.vue")
  },
  {
    name: "wrapping-box",
    path: "/wrapping/box",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/box.vue")
  },
  {
    name: "cargo-loading",
    path: "/cargo-loading",
    component: () => import("/var/www/2025-04-21_15_13/pages/cargo-loading.vue")
  },
  {
    name: "happybirthday",
    path: "/happybirthday",
    meta: happybirthday_45mjrOzhmWppU3T0I58vsqNMT02FW2zJNNiwTRnNpF_QMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/happybirthday.vue")
  },
  {
    name: "iframe-manage",
    path: "/iframe/manage",
    meta: manage__45ls8EI2X_MN4LHUZgVLYT_Bw3Um1sjKSIW1wfyaRbgMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/iframe/manage.vue")
  },
  {
    name: "personal-auth",
    path: "/personal/auth",
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/auth.vue")
  },
  {
    name: "ui-kit-public",
    path: "/ui-kit/public",
    component: () => import("/var/www/2025-04-21_15_13/pages/ui-kit/public.vue")
  },
  {
    name: "already-answer",
    path: "/already-answer",
    component: () => import("/var/www/2025-04-21_15_13/pages/already-answer.vue")
  },
  {
    name: "iframe-tariffs",
    path: "/iframe/tariffs",
    meta: tariffsHrw9pOemktDHjK0YG4f9BnBv9rTA52WZPxnU2BrIhOYMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/iframe/tariffs.vue")
  },
  {
    name: "order-pay-id",
    path: "/order/pay/:id()",
    component: () => import("/var/www/2025-04-21_15_13/pages/order/pay/[id].vue")
  },
  {
    name: "personal",
    path: "/personal",
    meta: indexbrR6k7lHMwYBuLIU10hOTWodZJUDkx2mndI9TQwYoRMMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/index.vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    component: () => import("/var/www/2025-04-21_15_13/pages/privacy-policy.vue")
  },
  {
    name: "welcome-hash",
    path: "/welcome/:hash()",
    component: () => import("/var/www/2025-04-21_15_13/pages/welcome/[hash].vue")
  },
  {
    name: "wrapping",
    path: "/wrapping",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/index.vue")
  },
  {
    name: "delivery-russia",
    path: "/delivery-russia",
    component: () => import("/var/www/2025-04-21_15_13/pages/delivery-russia.vue")
  },
  {
    name: "payment-methods",
    path: "/payment-methods",
    component: () => import("/var/www/2025-04-21_15_13/pages/payment-methods.vue")
  },
  {
    name: "payment-qr-info",
    path: "/payment/qr-info",
    component: () => import("/var/www/2025-04-21_15_13/pages/payment/qr-info.vue")
  },
  {
    name: "payment-success",
    path: "/payment/success",
    component: () => import("/var/www/2025-04-21_15_13/pages/payment/success.vue")
  },
  {
    name: "personal-import",
    path: "/personal/import",
    meta: importy9N3qLMaQGeJZCYMZth9Nb8dxqnkadbKQLxGRkxlcR4Meta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/import.vue")
  },
  {
    name: "personal-logout",
    path: "/personal/logout",
    meta: logoutXeyhjMQ2g5ZRy01exVISn6Bf21dx_9YBsB4aAZdsczAMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/logout.vue")
  },
  {
    name: "address-delivery",
    path: "/address-delivery",
    component: () => import("/var/www/2025-04-21_15_13/pages/address-delivery.vue")
  },
  {
    name: "cash-on-delivery",
    path: "/cash-on-delivery",
    component: () => import("/var/www/2025-04-21_15_13/pages/cash-on-delivery.vue")
  },
  {
    name: "happynewyear2024",
    path: "/happynewyear2024",
    meta: happynewyear2024hUx1uV_OqZE80vy05NCEb0M4KBMMXB8MBVo7Qmy3XDAMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/happynewyear2024.vue")
  },
  {
    name: "marketplace-ozon",
    path: "/ozon",
    meta: ozonZNlZOabiowwra1CD0lDVZIaKFEVJQKB2NZPmSCzyNnEMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/marketplace/ozon.vue")
  },
  {
    name: "payment-pay-fail",
    path: "/payment/pay-fail",
    component: () => import("/var/www/2025-04-21_15_13/pages/payment/pay-fail.vue")
  },
  {
    name: "personal-account",
    path: "/personal/account",
    meta: accountlUuAyjKdWh2RSCdDS90rvojN6HaCVYQf9UsAIBrk95gMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/account.vue")
  },
  {
    name: "prohibited-goods",
    path: "/prohibited-goods",
    component: () => import("/var/www/2025-04-21_15_13/pages/prohibited-goods.vue")
  },
  {
    name: "ui-kit-direction",
    path: "/ui-kit/direction",
    component: () => import("/var/www/2025-04-21_15_13/pages/ui-kit/direction.vue")
  },
  {
    name: "free-group-pickup",
    path: "/free-group-pickup",
    component: () => import("/var/www/2025-04-21_15_13/pages/free-group-pickup.vue")
  },
  {
    name: "free-pickup-cargo",
    path: "/free-pickup-cargo",
    component: () => import("/var/www/2025-04-21_15_13/pages/free-pickup-cargo.vue")
  },
  {
    name: "iframe-calculator",
    path: "/iframe/calculator",
    meta: calculatori3Hta6d4qBipG2OXdigCnBopQyqKLXV6Zy4kWCj1e5UMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/iframe/calculator.vue")
  },
  {
    name: "merch-for-bonuses",
    path: "/merch-for-bonuses",
    component: () => import("/var/www/2025-04-21_15_13/pages/merch-for-bonuses.vue")
  },
  {
    name: "order-pay-qr-id",
    path: "/order/pay/qr/:id()",
    component: () => import("/var/www/2025-04-21_15_13/pages/order/pay/qr/[id].vue")
  },
  {
    name: "payment-card-info",
    path: "/payment/card-info",
    component: () => import("/var/www/2025-04-21_15_13/pages/payment/card-info.vue")
  },
  {
    name: "personal-discount",
    path: "/personal/discount",
    meta: discountjcespzT3nbE4OmHgIdqw2TFp8CbRjL9G0xIWnMMTJtMMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/discount.vue")
  },
  {
    name: "wrapping-hard-box",
    path: "/wrapping/hard-box",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/hard-box.vue")
  },
  {
    name: "forwarding-receipt",
    path: "/forwarding-receipt",
    component: () => import("/var/www/2025-04-21_15_13/pages/forwarding-receipt.vue")
  },
  {
    name: "mailClient10201917",
    path: "/mailClient10201917",
    meta: mailClient10201917N8A5Tyk4UqZR7kV9qmeGnMEhlwCyOq1J4g2T6zerxNYMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/mailClient10201917.vue")
  },
  {
    name: "mobile-application",
    path: "/mobile-application",
    component: () => import("/var/www/2025-04-21_15_13/pages/mobile-application.vue")
  },
  {
    name: "order-create",
    path: "/order/create",
    meta: indexRniHaUCMLUyZTYaMXyqTZ0mg7Zbu_45AZPobYWLhT33gUMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/order/create/index.vue")
  },
  {
    name: "shippingtypes-boat",
    path: "/shippingtypes/boat",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/boat.vue")
  },
  {
    name: "shippingtypes-sofa",
    path: "/shippingtypes/sofa",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/sofa.vue")
  },
  {
    name: "wrapping-cardboard",
    path: "/wrapping/cardboard",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/cardboard.vue")
  },
  {
    name: "personal-promocodes",
    path: "/personal/promocodes",
    meta: promocodesh8Us6sol_IFoR169lE8P9awC3eWSaYSADfsqxH8HUC0Meta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/promocodes.vue")
  },
  {
    name: "shippingtypes-bench",
    path: "/shippingtypes/bench",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/bench.vue")
  },
  {
    name: "shippingtypes-books",
    path: "/shippingtypes/books",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/books.vue")
  },
  {
    name: "shippingtypes-cable",
    path: "/shippingtypes/cable",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/cable.vue")
  },
  {
    name: "shippingtypes-chair",
    path: "/shippingtypes/chair",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/chair.vue")
  },
  {
    name: "shippingtypes-goods",
    path: "/shippingtypes/goods",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/goods.vue")
  },
  {
    name: "shippingtypes",
    path: "/shippingtypes",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/index.vue")
  },
  {
    name: "shippingtypes-metal",
    path: "/shippingtypes/metal",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/metal.vue")
  },
  {
    name: "shippingtypes-piano",
    path: "/shippingtypes/piano",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/piano.vue")
  },
  {
    name: "shippingtypes-pipes",
    path: "/shippingtypes/pipes",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/pipes.vue")
  },
  {
    name: "shippingtypes-tools",
    path: "/shippingtypes/tools",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/tools.vue")
  },
  {
    name: "wrapping-pallet-box",
    path: "/wrapping/pallet-box",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/pallet-box.vue")
  },
  {
    name: "personal-bonus-tab",
    path: "/personal/bonus/:tab()",
    meta: _91tab_93SXfoB8sLZqYvI0VUYBGKqJm9FsiPzkPoK0Vo_LXG7bsMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/bonus/[tab].vue")
  },
  {
    name: "personal-order-print",
    path: "/personal/order/print",
    meta: printjgs0BXLvHX9wREGViBMZo_45OFPU_45IshH78w70seGOxMgMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/order/print.vue")
  },
  {
    name: "shippingtypes-dishes",
    path: "/shippingtypes/dishes",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/dishes.vue")
  },
  {
    name: "shippingtypes-engine",
    path: "/shippingtypes/engine",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/engine.vue")
  },
  {
    name: "shippingtypes-lumber",
    path: "/shippingtypes/lumber",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/lumber.vue")
  },
  {
    name: "shippingtypes-wheels",
    path: "/shippingtypes/wheels",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/wheels.vue")
  },
  {
    name: "wrapping-bubble-film",
    path: "/wrapping/bubble-film",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/bubble-film.vue")
  },
  {
    name: "wrapping-palletising",
    path: "/wrapping/palletising",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/palletising.vue")
  },
  {
    name: "fast-delivery-capital",
    path: "/fast-delivery-capital",
    component: () => import("/var/www/2025-04-21_15_13/pages/fast-delivery-capital.vue")
  },
  {
    name: "personal-order-guid",
    path: "/personal/order/:tag(pay)?/:guid",
    meta: _91guid_93wKwqZzWqHPw7R7CmfitAw_45BnILI6gPRo8chVWOYPmDQMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/order/[guid].vue")
  },
  {
    name: "personal-order-create",
    path: "/personal/order/create",
    meta: createTXKPDArZ4SFyEUb4GbgcSJ6ymrXc_45taZPxk_45sHIEV3QMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/order/create.vue")
  },
  {
    name: "shippingtypes-barrels",
    path: "/shippingtypes/barrels",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/barrels.vue")
  },
  {
    name: "shippingtypes-clothes",
    path: "/shippingtypes/clothes",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/clothes.vue")
  },
  {
    name: "shippingtypes-fragile",
    path: "/shippingtypes/fragile",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/fragile.vue")
  },
  {
    name: "shippingtypes-trailer",
    path: "/shippingtypes/trailer",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/trailer.vue")
  },
  {
    name: "wrapping-safe-package",
    path: "/wrapping/safe-package",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/safe-package.vue")
  },
  {
    name: "payment-bepaid-success",
    path: "/payment/bepaid-success",
    component: () => import("/var/www/2025-04-21_15_13/pages/payment/bepaid-success.vue")
  },
  {
    name: "wrapping-extra-package",
    path: "/wrapping/extra-package",
    component: () => import("/var/www/2025-04-21_15_13/pages/wrapping/extra-package.vue")
  },
  {
    name: "marketplace-wildberries",
    path: "/wildberries",
    meta: wildberriesJc6fQnmNbng3WZV7evgM_45aKwlzj8q3k90ZOvbJuNCqAMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/marketplace/wildberries.vue")
  },
  {
    name: "order-administer-guid",
    path: "/order/administer/:guid()",
    component: () => import("/var/www/2025-04-21_15_13/pages/order/administer/[guid].vue")
  },
  {
    name: "shippingtypes-furniture",
    path: "/shippingtypes/furniture",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/furniture.vue")
  },
  {
    name: "shippingtypes-oversized",
    path: "/shippingtypes/oversized",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/oversized.vue")
  },
  {
    name: "shippingtypes-quad-bike",
    path: "/shippingtypes/quad-bike",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/quad-bike.vue")
  },
  {
    name: "order-create-locations",
    path: "/order/create/:locations()",
    component: () => import("/var/www/2025-04-21_15_13/pages/order/create/[locations].vue")
  },
  {
    name: "personal-orders-tab",
    path: "/personal/orders/:tab(.*)*",
    meta: _91_46_46_46tab_93zIAK0qUWGkilHeJnGrhFOZCtgdHXgFd0js6qg6IqCgMMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/orders/[...tab].vue")
  },
  {
    name: "shippingtypes-auto-parts",
    path: "/shippingtypes/auto-parts",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/auto-parts.vue")
  },
  {
    name: "shippingtypes-newspapers",
    path: "/shippingtypes/newspapers",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/newspapers.vue")
  },
  {
    name: "shippingtypes-smallcargo",
    path: "/shippingtypes/smallcargo",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/smallcargo.vue")
  },
  {
    name: "shippingtypes-snowmobile",
    path: "/shippingtypes/snowmobile",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/snowmobile.vue")
  },
  {
    name: "iframe-order-create",
    path: "/iframe/order/create",
    meta: index_JymTZA639nG_451OnqQyBaUOcZXc_bEfecExB__yEAfEMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/iframe/order/create/index.vue")
  },
  {
    name: "marketplace-yandex-market",
    path: "/yandex-market",
    meta: yandex_45marketOQJgxP4o14w97HMQVqdJuvpMHPDdqfZG_45UpX6LhWtg8Meta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/marketplace/yandex-market.vue")
  },
  {
    name: "personal-orders-templates",
    path: "/personal/orders/templates",
    meta: templatesg_45j8sct_45kXjy7qf8bd9dgp3Ha6aOk5Pg8BHNOvSkNR4Meta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/orders/templates.vue")
  },
  {
    name: "personal-contractors",
    path: "/personal/contractors",
    meta: indexPC_8ONyzYoLzLrjZ5PQFgKLihGjY003gNi_45A1WqF42IMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/contractors/index.vue")
  },
  {
    name: "shippingtypes-refrigerator",
    path: "/shippingtypes/refrigerator",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/refrigerator.vue")
  },
  {
    name: "personal-contractors-guid",
    path: "/personal/contractors/:guid()",
    meta: _91guid_93_j9W_45E_DNlgXkHFuKOb_45oZZi5xKWjNL1kpR_qifSRaEMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/contractors/[guid].vue")
  },
  {
    name: "personal-multi-pickup",
    path: "/personal/multi-pickup",
    meta: indexXJ7xU4G3qbB5xQ_45EpJ76LqBNOGfh2TTAj2RpZkllzhgMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/multi-pickup/index.vue")
  },
  {
    name: "personal-multi-pickup-guid",
    path: "/personal/multi-pickup/:guid",
    meta: _91guid_93nop5lB0gwq2UGpsQScqlUDB6_45qks3wzG27_45dVqZ2f34Meta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/multi-pickup/[guid].vue")
  },
  {
    name: "shippingtypes-consumer-goods",
    path: "/shippingtypes/consumer-goods",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/consumer-goods.vue")
  },
  {
    name: "personal-group-printing",
    path: "/personal/group-printing",
    meta: indexubXP3AwqrlSxS75cWG6V0KcWCAv4tENs9CCwX2tqCgkMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/group-printing/index.vue")
  },
  {
    name: "personal-multi-delivery",
    path: "/personal/multi-delivery",
    meta: indexqnqP7IsKIIXSuNYeZLZyMzwW9YE23Ckrp4DHtYCydoAMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/multi-delivery/index.vue")
  },
  {
    name: "shippingtypes-medical-devices",
    path: "/shippingtypes/medical-devices",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/medical-devices.vue")
  },
  {
    name: "iframe-order-administer-guid",
    path: "/iframe/order/administer/:guid()",
    meta: _91guid_93B142TTO2LCoLcqe4Qyxu0DyYKB4KY5lPAosooy9b0HMMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/iframe/order/administer/[guid].vue")
  },
  {
    name: "personal-multi-delivery-guid",
    path: "/personal/multi-delivery/:guid",
    meta: _91guid_93T_edXAxDoyja6VKfCH1Z0UORs4aCqp0oDM7klIQI6YsMeta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/multi-delivery/[guid].vue")
  },
  {
    name: "personal-order-template-id",
    path: "/personal/order/template/:id(.*)*",
    meta: _91_46_46_46id_93eMxPJRxlUx7eKtLracMY6maRczv8_IxiFIpIBJ7R0b0Meta || {},
    component: () => import("/var/www/2025-04-21_15_13/pages/personal/order/template/[...id].vue")
  },
  {
    name: "shippingtypes-special-equipment",
    path: "/shippingtypes/special-equipment",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/special-equipment.vue")
  },
  {
    name: "shippingtypes-building-materials",
    path: "/shippingtypes/building-materials",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/building-materials.vue")
  },
  {
    name: "shippingtypes-musical-instruments",
    path: "/shippingtypes/musical-instruments",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/musical-instruments.vue")
  },
  {
    name: "shippingtypes-industrial-equipment",
    path: "/shippingtypes/industrial-equipment",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/industrial-equipment.vue")
  },
  {
    name: "shippingtypes-motorcycletransportation",
    path: "/shippingtypes/motorcycletransportation",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/motorcycletransportation.vue")
  },
  {
    name: "order-create-locationFrom_locationTo",
    path: "/order/create/:locationFrom()_:locationTo()",
    component: () => import("/var/www/2025-04-21_15_13/pages/order/create/[locationFrom]_[locationTo].vue")
  },
  {
    name: "shippingtypes-personalitemstransportation",
    path: "/shippingtypes/personalitemstransportation",
    component: () => import("/var/www/2025-04-21_15_13/pages/shippingtypes/personalitemstransportation.vue")
  }
]